export default function AlmostEqual(): React.JSX.Element {
  return (
    <svg
      fill="#F1BE33"
      width="30px"
      height="30px"
      viewBox="0 0 12 14"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m 7,8.8385971 c -1.1946,-0.3988 -1.944,-0.4259 -2.39275,-0.086 C 4.1109,9.1274971 4,9.0840971 4,8.5145971 c 0,-1.0579 0.98405,-1.2801 3.15745,-0.7131 1.40955,0.3678 1.62595,0.3844 2.0757,0.1596 0.2762,-0.138 0.5617,-0.2799 0.6345,-0.3154 0.0728,-0.035 0.13235,0.1783 0.13235,0.4751 0,0.4191 -0.1163,0.5998 -0.52065,0.8088 -0.65705,0.3398 -1.2548,0.3179 -2.47935,-0.091 z m 0,-2.647 c -1.1946,-0.3989 -1.944,-0.426 -2.39275,-0.087 C 4.1109,6.4803971 4,6.4370971 4,5.8674971 c 0,-1.0307 1.1159,-1.3118 2.9706,-0.7485 1.45335,0.4415 1.9587,0.4654 2.42215,0.1149 0.4989,-0.3774 0.60725,-0.3319 0.60725,0.2546 0,0.4027 -0.12115,0.5875 -0.52065,0.7941 -0.65705,0.3397 -1.2548,0.3178 -2.47935,-0.091 z" />
    </svg>
  );
}
